// extracted by mini-css-extract-plugin
module.exports = {"item":"Index_item__1W7na","name":"Index_name__1P3Lw"};